import { useEffect } from 'react';

export const useOutsideClick = (
  ref: React.MutableRefObject<any>,
  cb: () => void,
  conditionToTriggerCB?: string
) => {
  const handleClickOutside = (event: Event) => {
    if (ref instanceof Array) {
      const outsides = ref
        .map(excRef => !excRef.current?.contains(event.target))
        .filter(result => result);
      if (outsides.length === ref.length) cb();
    } else if (!ref.current?.contains(event.target)) {
      const target = event.target as Element;
      if (target && conditionToTriggerCB && target?.className !== conditionToTriggerCB) {
        return;
      }

      cb();
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
